// https://github.com/silentmatt/javascript-biginteger
import { BigInteger } from 'biginteger';

// Expose BigInteger
window.BigInteger = BigInteger;
